import { useEffect, useRef, useState, type ReactNode } from 'react'
export function ParentHoldButton({ onOpen, children, className = '', label = '长按两秒进入家长页面' }: { onOpen(): void; children?: ReactNode; className?: string; label?: string }) {
  const timer = useRef<number>()
  const [holding, setHolding] = useState(false)
  const cancel = () => { window.clearTimeout(timer.current); timer.current = undefined; setHolding(false) }
  const begin = () => {
    if (timer.current !== undefined) return
    setHolding(true)
    timer.current = window.setTimeout(() => { timer.current = undefined; setHolding(false); onOpen() }, 2000)
  }
  useEffect(() => () => window.clearTimeout(timer.current), [])
  return <button aria-label={label} className={`relative overflow-hidden select-none ${className}`}
    onPointerDown={(event) => { if (event.button === 0) begin() }} onPointerUp={cancel} onPointerLeave={cancel} onPointerCancel={cancel}
    onKeyDown={(event) => { if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); if (!event.repeat) begin() } }}
    onKeyUp={(event) => { if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); cancel() } }}
    onBlur={cancel} onContextMenu={(event) => event.preventDefault()}>
    {children}<span className="text-xs font-semibold">{holding ? '保持按住…' : '长按 2 秒'}</span>
    {holding && <span className="absolute inset-x-0 bottom-0 h-1 animate-[hold_2s_linear_forwards] bg-sun" />}
  </button>
}
